export default __webpack_public_path__ + "static/media/OxyAceWeldingImg.9034da67.jpg";